import { useParams } from "react-router-dom";
import { MeetingView } from "../components/meetings/MeetingView";

function Meeting() {
  const { sqid } = useParams();
  return (
    <div style={{ maxWidth: "1200px", width: "100%", boxSizing: "border-box" }}>
      <MeetingView key={sqid} sqid={sqid} variant="page" />
    </div>
  );
}

export default Meeting;
